import { map } from "rxjs";
import { TipsMap } from "../model";
import { apiService } from "./ApiService";

export const getGameTips = (gameId: string) => {
  return apiService
    .get<{ tips: TipsMap }>({
      path: `public/tips/games/${gameId}`,
      edito: true,
    })
    .pipe(
      map(({ tips }) => {
        return tips;
      }),
    );
};
